import ReactGA4 from 'react-ga4'

// Stocker le center_user_id globalement pour l'inclure dans tous les événements
let currentCenterUserId: string | null = null

const InitializeGoogleAnalytics = (user_id: string) => {
  // Stocker le center_user_id
  currentCenterUserId = user_id
  
  // Initialize GA4 - Add your measurement ID
  ReactGA4.initialize([
    {
      trackingId: process.env?.REACT_APP_GA4_TRACKID ?? '',
      gaOptions: {
        userId: user_id,
        debug_mode: process.env.NODE_ENV === 'development' || false,
      },
      gtagOptions: {
        debug_mode: process.env.NODE_ENV === 'development' || false,
      },
    },
  ])
  
  // IMPORTANT: Envoyer center_user_id comme paramètre d'événement, pas comme user_property
  // Les user_properties ne sont pas accessibles via l'API GA4 Data
  ReactGA4.event('user_identified', {
    center_user_id: user_id,
  })
  
  console.log('GA INITIALIZED with center_user_id:', user_id)
}

const TrackGoogleAnalyticsEvent = (
  category: string,
  action: string,
  label: string,
  data?: Record<string, unknown>,
) => {
  console.log('GA event:', category, ':', action, ':', label, 'center_user_id:', currentCenterUserId)

  // IMPORTANT: Toujours inclure center_user_id dans TOUS les événements
  const event_params = {
    category,
    label,
    center_user_id: currentCenterUserId, // Ajout du center_user_id
    ...data,
  }

  // Send GA4 Event
  ReactGA4.event(action, event_params)
}

// Fonction helper pour les page views (très important)
const TrackPageView = (path?: string) => {
  const pageViewParams = {
    page_path: path || window.location.pathname + window.location.search,
    page_location: window.location.href,
    page_title: document.title,
    center_user_id: currentCenterUserId, // CRUCIAL: inclure center_user_id
  }
  
  ReactGA4.send({ 
    hitType: 'pageview',
    ...pageViewParams
  })
  
  // Alternative: utiliser event page_view (recommandé pour GA4)
  ReactGA4.event('page_view', pageViewParams)
}

export default InitializeGoogleAnalytics
export { InitializeGoogleAnalytics, TrackGoogleAnalyticsEvent, TrackPageView }
